import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c96008"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvBJ" }
const _hoisted_2 = { class: "dvQuestion" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"dv-bottom\" data-v-60c96008><div class=\"dv-next\" data-v-60c96008><button class=\"dv-btn\" data-v-60c96008>下一题</button></div><div class=\"dv-previous\" data-v-60c96008><button class=\"dv-btn\" data-v-60c96008>上一题</button></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_choice_question = _resolveComponent("choice-question")!
  const _component_multiple_question = _resolveComponent("multiple-question")!
  const _component_true_or_false_question = _resolveComponent("true-or-false-question")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.question.type === 1)
        ? (_openBlock(), _createBlock(_component_choice_question, {
            key: 0,
            question: _ctx.question
          }, null, 8, ["question"]))
        : _createCommentVNode("", true),
      (_ctx.question.type === 2)
        ? (_openBlock(), _createBlock(_component_multiple_question, {
            key: 1,
            question: _ctx.question
          }, null, 8, ["question"]))
        : _createCommentVNode("", true),
      (_ctx.question.type === 4)
        ? (_openBlock(), _createBlock(_component_true_or_false_question, {
            key: 2,
            question: _ctx.question,
            onChangePartsAnswer: _ctx.changePartsAnswer
          }, null, 8, ["question", "onChangePartsAnswer"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_3
  ]))
}